/**
 * Days remaining until the given ISO 8601 timestamp. Used by
 * MetaTokenExpiringBanner to render copy like "expires in 5 days" — the
 * backend's TOKEN_REPROMPT_WINDOW is 7 days, so the banner only renders
 * when this returns ≤ 7.
 *
 * Returns a non-negative integer; clamps to 0 for past timestamps so the
 * banner never renders "expires in -2 days". Caller should still handle
 * the past-expiry case by separately checking the source-of-truth
 * `tokenExpiringSoon` flag.
 */
export function daysUntil(isoTimestamp: string): number {
  const expiry = new Date(isoTimestamp).getTime();
  if (Number.isNaN(expiry)) return 0;
  const diffMs = expiry - Date.now();
  if (diffMs <= 0) return 0;
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}
